import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [dataExcel, setDataExcel] = useState(undefined);
  const [dataImport, setDataImport] = useState({});

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listSupervisors(zone) {
    let response = await wsFindBy('base/supervisor-v2', { state: 'A', deleted: 'null', codsede: zone });
    if (response.success) setSupervisors(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging([]);
      listZones();
      setDataExcel(undefined);
    }
  }, [cuota.open]);

  useEffect(() => {
    if (zones.length > 0 && cuota.codsede) {
      handleChange("codsede", String(cuota.codsede));
    }
  },[zones]);

  useEffect(() => {
    if (dataChanging.codsede !== undefined && dataChanging.codsede !== null) {
      listSupervisors(dataChanging.codsede);
    }
  },[dataChanging.codsede]);

  useEffect(() => {
    if (supervisors.length > 0 && cuota.codSupervisor) {
      handleChange("codSupervisor", String(cuota.codSupervisor));
    }
  },[supervisors]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setDataExcel({
        success: dataImport.success,
        supervisors: dataImport.data.map((item) => {
          return {
            base_zone_code: item.ZONAL,
            base_supervisor_code: item.SUPERVISOR.toString(),
            tipo: item.TIPO,
            cuota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setDataExcel(undefined);
    }
  }, [dataImport]);


  return (
    <>
      <Modal
        title={`Nueva Cuota de Supervisor para Verdum`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataExcel?.success
            ? 'sale/cuota-supervisor/multiple'
            : 'sale/cuota-supervisor'
        }
        dataForce={
          dataChanging.codsede
            ? {
              codsede: dataChanging.codsede,
              codSupervisor: dataChanging.codSupervisor
            }
            : {
                supervisors: dataExcel?.supervisors,
            }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Sede" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('codsede', item?.code);setDataImport(null);}}
            value={zones.find((zone) => String(zone.code) === String(dataChanging.codsede)) || null }
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['ZONAL','SUPERVISOR','TIPO']}
            sortDuplicate={['ZONAL','SUPERVISOR','TIPO']}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.periodo).format('YYYY-MM')}_Plantilla de cuota para supervisor`,
              fields: ['ZONAL','SUPERVISOR','TIPO','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.codsede ? (
          <>
            <Autocomplete
              disableClearable
              options={supervisors}
              getOptionLabel={(item) => `${item.name}`}
              renderInput={(params) => (
                <TextField {...params} label="Supervisor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('codSupervisor', item?.code);}}
              value={supervisors.find((sup) => String(sup.code) === String(dataChanging.codSupervisor)) || null }
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                defaultValue={!!cuota ? cuota.tipo : ''}
                inputProps={{
                  name: 'tipo',
                }}
              >
                <MenuItem value="O">Venta</MenuItem>
                <MenuItem value="I">Compra</MenuItem>
                <MenuItem value="C">Cobertura</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Cuota"
              fullWidth
              type="number"
              name="cuota"
              margin="normal"
              defaultValue={!!cuota ? cuota.cuota : ''}
              onChange={(e) => handleChange('cuota', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});

